import { NumOp, TextOp } from './filterTypes';

export const NUM_OP_SYMBOL: Record<NumOp, string> = {
    gte: '>=',
    lte: '<=',
    gt: '>',
    lt: '<',
    eq: '=',
};

export const NUM_OP_LABELS: Record<NumOp, string> = {
    gte: 'greater than equal to',
    lte: 'less than equal to',
    gt: 'greater than',
    lt: 'less than',
    eq: 'equals',
};

export const TEXT_OP_LABELS: Record<TextOp, string> = {
    li: 'contains',
    eq: 'equals',
};
